import type { SearchResult } from '@core/Areas/Search/types'
import { get } from '@core/Services/ApiService'

export const getRacingSearchResults = (searchTerm: string) => {
  return get<{ results: SearchResult[] }>({
    url: `/api/search/query?q=${searchTerm}&includeUnmatched`,
  })
}
